import "./form-service.scss";
import { useFormContext } from "react-hook-form";
import { ServiceFormSchema } from "@factory/form/form.rule";
import InputDigitControl from "@shared/ui/hook-form/input-digit-control/input-digit-control";
import InputControl from "@shared/ui/hook-form/input-control/input-control";
import CheckboxControl from "@shared/ui/hook-form/checkbox-control/checkbox-control";
import InputTextareaControl from "@shared/ui/hook-form/input-textarea-control/input-textarea-control";

type InputFormSchema = ServiceFormSchema;
export function FormService() {
  const { control } = useFormContext<ServiceFormSchema>();
  return (
    <div id="FormService" className="service">
      <InputControl<InputFormSchema>
        control={control}
        name="name"
        label="Name"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter name"
      />
      <InputTextareaControl<InputFormSchema>
        control={control}
        name="description"
        label="Description"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter description"
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="amount"
        label="Amount"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter amount"
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="duration"
        label="Duration (Minutes)"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter duration"
      />

      <CheckboxControl<InputFormSchema>
        control={control}
        name="isOpenTime"
        label="Is Open Time"
        containerClassName="pb-2"
      />
      {/* <InputDigitControl<InputFormSchema>
        control={control}
        name="upgrade"
        label="Upgrade"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter upgrade"
      /> */}
      <CheckboxControl<InputFormSchema>
        control={control}
        name="isSubscription"
        label="Is Subscription Based"
        containerClassName="pb-2"
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="days"
        label="Subscription days"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter Subscription days"
      />
      <CheckboxControl<InputFormSchema>
        control={control}
        name="isActive"
        label="Is Active"
        containerClassName="pb-2"
      />
    </div>
  );
}

export default FormService;
